<h2 mat-dialog-title>
  <div style="margin:0;color: #b71c1c; text-align: center;">
    WARNING
  </div>
</h2>
<mat-dialog-content>
  <div style="width:500px; padding: 10px 20px;">
    <div>
      The following dates are not school days for this student:
    </div>
    <div style="padding-left: 20px; padding-top: 20px; padding-bottom: 20px;">
      <ul>
        <li *ngFor="let date of dates">
          {{date | date: 'fullDate'}}
        </li>
      </ul>
    </div>
    <div>
      If this is correct, select Continue. Otherwise, select Cancel and change the dates.
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <tyl-button image="save.png" label="Continue" (clickEvent)="continueClick()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>